module.exports = __webpack_public_path__ + "img/game-avatar-3.7db15d73.png";